import { useSpecificLockerActionContext } from "../../contexts/SpecificLockerActionContext";
import { Locker, WordHighlightRange } from "../../data/LockerDataTypes";
import { ROUTE, STORAGE_BASE_URL } from "../../Settings";
import LockerItemIcon from "./LockerItemIcon";

export interface LockerListItemProps {
    locker: Locker
}

const lockerImage = `${STORAGE_BASE_URL}${ROUTE}/Logo_Easybox2.png`;
const EASYBOX = 'easybox';
const reEasybox = new RegExp(EASYBOX, 'gi');

const LockerListItem = ({ locker }: LockerListItemProps) => {
    const { setLockerListSelected } = useSpecificLockerActionContext();

    const onLockerSelected = (selectedLocker: Locker): void => {
        setLockerListSelected(selectedLocker);
    };

    const highlightProperty = (propertyText: string, range: WordHighlightRange): JSX.Element => {
        let value = <>{propertyText}</>;
        if (range) {
            const start = propertyText.slice(0, range.startIndex);
            const middle = propertyText.slice(range.startIndex, range.endIndex);
            const end = propertyText.slice(range.endIndex, propertyText.length);

            value = middle.trim() == '' ? value : <>{start}<b>{middle}</b>{end}</>;
        }
        return value;
    }

    const getLockerName = (locker: Locker): JSX.Element => {
        const name = locker.name.replace(reEasybox, ' '.repeat(EASYBOX.length));
        return highlightProperty(name, locker.nameHighlight)
    }

    return (
        <li className="list-group-item" onClick={() => onLockerSelected(locker)}>
            <div className="d-flex">
                <img style={{ width: "63px", height: "16px" }} className={'mt-1 position-relative'} src={lockerImage}></img>
                <span className="a-bit-of-margin-left">{getLockerName(locker)}</span>
                <LockerItemIcon locker={locker} />
            </div>
            <div>
                <small className="text-muted">
                    {highlightProperty(locker.address, locker.addressHighlight)},
                    {highlightProperty(locker.city, locker.cityHighlight)},
                    {highlightProperty(locker.county, locker.countyHighlight)}
                </small>
            </div>
        </li>
    );
}

export default LockerListItem;
